import { default as Login } from './Login';
import { default as Register } from './Register';
const Auth = {
	Login,
	Register
};

export default Auth;
